module.exports = __webpack_public_path__ + "1791188489487/fonts/socicon.9a64ef9.ttf";